import reduxIncrementEventTrackerNbr from "../../pages/Objects/redux_increment_event_tracker_nbr";
import { calculateJobSalary } from "../AssetsExpenses/calculate_job_salary";
import { calcMonthlyIncome } from "./calcMonthlyIncome";

export const createEventTrackerUpdateObject = (eventType, process, gameData, eventObj, creditCardInfo) => {
    let dataObject = {};
    const monthlyIncomeObj = calcMonthlyIncome(gameData.assetTable, gameData.expenseTable, gameData.loanTable);
    let jobSalary = calculateJobSalary(gameData.assetTable, gameData.currentGameDate, false);
    jobSalary = jobSalary.toFixed(2);
    const eventTrackerGameData = { gameDate: gameData.currentGameDate,
        beforeCash: gameData.currentCash,
        // the following is total salary including awards and extra credit it does not include house rent paid
        // by roommates
        beforeSalary: jobSalary.toString(),  
        beforeMoodPoints: gameData.currentMoodPoints,
        monthlyIncome: monthlyIncomeObj.income,   
        totalAssets: monthlyIncomeObj.assets,
        totalExpenses: monthlyIncomeObj.expenses,
        totalLoans: monthlyIncomeObj.loans,
        creditCardActive: creditCardInfo.currentlyActive,
        creditCardBalance: creditCardInfo.totalOutstandingBalance,
        creditCardMaxAmt: creditCardInfo.creditMaxAmount,
        expenseTable: gameData.expenseTable
    }
    const eventTrackerNbr = reduxIncrementEventTrackerNbr("INCREMENTEVENTTRACKER");
    dataObject = {
        eventNbr: eventTrackerNbr,
        user: gameData.user,
        gameID: gameData._id,
        eventType: eventType,
        process: process,
        gameData: eventTrackerGameData,
        event: eventObj,
    }
    return dataObject;
}
export default createEventTrackerUpdateObject;